// @flow @jsx h

import { h } from 'preact'
import style from './index.css'

type Props = {
  value: string
}

function Paragraph (props: Props) {
  const { value } = props
  return (
    <p
      className={style.paragraph}
      dangerouslySetInnerHTML={{ __html: value }}
    />
  )
}

export default Paragraph



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/Paragraph/index.js